import { Star } from '@phosphor-icons/react';

export function StarRating({ rating, size = 14, interactive = false, onChange }) {
    return (
        <div className="flex gap-0.5" data-testid="star-rating">
            {[1, 2, 3, 4, 5].map(i => (
                <button key={i} disabled={!interactive}
                    onClick={() => interactive && onChange?.(i)}
                    className={interactive ? 'cursor-pointer' : 'cursor-default'}>
                    <Star size={size} weight={i <= rating ? 'fill' : 'regular'}
                        className={i <= rating ? 'text-neon-gold' : 'text-muted-foreground/30'} />
                </button>
            ))}
        </div>
    );
}
